import { all, call, takeLatest, put } from 'redux-saga/effects'
import {
  rejectPromiseAction,
  resolvePromiseAction
} from 'redux-saga-promise-actions'
import * as actions from './actions'
import * as services from './services'

export function * createPickupQueue (action) {
  try {
    const { payload } = action
    const response = yield call(services.createPickupQueue, payload)
    resolvePromiseAction(action, response)
  } catch (error) {
    rejectPromiseAction(action, error)
    console.error(error)
  }
}

export function * getQueuesCounter (action) {
  try {
    const response = yield call(services.getQueuesCounter)
    resolvePromiseAction(action, response)
  } catch (error) {
    rejectPromiseAction(action, error)
    console.error(error)
  }
}

export function * deletePickupQueue (action) {
  try {
    const { payload } = action
    const response = yield call(services.deleteQueue, payload)
    resolvePromiseAction(action, response)
  } catch (error) {
    rejectPromiseAction(action, error)
    console.error(error)
  }
}

export function * editPickupQueue (action) {
  try {
    const { payload } = action
    const response = yield call(services.editQueue, payload)
    resolvePromiseAction(action, response)
  } catch (error) {
    rejectPromiseAction(action, error)
    console.error(error)
  }
}

export function * getPickupQueue ({ payload }) {
  try {
    const currentPage = payload.page || 1
    const response = yield call(services.getPickupQueues, payload)
    yield put(
      actions.getPickupQueueSuccessful({
        response,
        current_page: currentPage
      })
    )
  } catch (error) {
    yield put(actions.getPickupQueueFailure(error))
  }
}

function * watchFetchQueue () {
  yield takeLatest(actions.createPickupQueueRSPA.request, createPickupQueue)
  yield takeLatest(actions.getPickupQueue, getPickupQueue)
  yield takeLatest(actions.getQueuesCounterRSPA.request, getQueuesCounter)
  yield takeLatest(actions.editPickupQueueRSPA.request, editPickupQueue)
  yield takeLatest(actions.deletePickupQueueRSPA.request, deletePickupQueue)
}

export default function * pickupAuthorizationsSagas () {
  yield all([watchFetchQueue()])
}
